<div>
  <ng-container *transloco="let t; prefix: 'home'">
    @if (!isDesignRoute()) {
      <span style="font-family: cursive; font-size: large; text-align: center; padding-bottom: 20px"
        ><em>{{ t('introduction') }}</em></span
      >
    }
    <pp-cards-grid [cards]="cards"></pp-cards-grid>
  </ng-container>
</div>
